export const CREATE_OFFICER_ATTENDANCE_MUTATION = `
  mutation createOfficerAttendance($inputData: OfficerAttendanceInput!) {
    createOfficerAttendance(inputData: $inputData){
      __typename
    }
  }
`;
export const DELETE_ATTENDANCE_MUTATION = `
  mutation deleteAttendance($attendanceId: DocumentId!) {
    deleteAttendance(attendanceId: $attendanceId){
      __typename
    }
  }
`;
export const UPDATE_ATTENDANCE_MUTATION = `
  mutation updateAttendance($attendanceId: DocumentId!, $inputData: UpdateAttendanceInput!) {
    updateAttendance(attendanceId: $attendanceId, inputData:$inputData){
      __typename
    }
  }
`;
export const UPDATE_WORKSHOP_MUTATION = `
  mutation updateWorkshop($workshopId: DocumentId!, $inputData: UpdateWorkshopForm!) {
    updateWorkshop(workshopId: $workshopId, inputData: $inputData) {
      __typename
      ...on WorkshopError {
        message
      }
    }
  }
`;
